import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "nav-links" }
const _hoisted_3 = { class: "nav-actions" }
const _hoisted_4 = { class: "mobile-nav-links" }
const _hoisted_5 = { class: "mobile-nav-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LanguageSwitch = _resolveComponent("LanguageSwitch")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "logo" }, " AuthentiGuard ", -1)),
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nav.home')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/report" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nav.report')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.scrollToStats && $setup.scrollToStats(...args)))
      }, _toDisplayString(_ctx.$t('nav.achievements')), 1),
      _createVNode(_component_router_link, { to: "/calendar" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nav.calendar')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/brand" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nav.brands')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_LanguageSwitch)
    ]),
    _createElementVNode("div", {
      class: "mobile-menu-btn",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggleMobileMenu && $setup.toggleMobileMenu(...args)))
    }, [
      _createVNode(_component_van_icon, { name: "wap-nav" })
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "mobile-menu",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.toggleMobileMenu && $setup.toggleMobileMenu(...args)))
    }, [
      _createElementVNode("div", {
        class: "mobile-menu-content",
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("nav", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            onClick: $setup.closeMobileMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.home')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/report",
            onClick: $setup.closeMobileMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.report')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("a", {
            href: "javascript:void(0)",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleMobileAchievementsClick && $setup.handleMobileAchievementsClick(...args)))
          }, _toDisplayString(_ctx.$t('nav.achievements')), 1),
          _createVNode(_component_router_link, {
            to: "/calendar",
            onClick: $setup.closeMobileMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.calendar')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/brand",
            onClick: $setup.closeMobileMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.brands')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_LanguageSwitch)
        ])
      ])
    ], 512), [
      [_vShow, $setup.showMobileMenu]
    ])
  ]))
}